import { UrlSerializer, UrlTree, DefaultUrlSerializer } from '@angular/router';

// Permet de décoder les / dans l'url
// Ex : http://localhost:8100/?panel=detail%2F00000943-aaaa-aaaa-aaaa-756761755f73
// Res : http://localhost:8100/?panel=detail/00000943-aaaa-aaaa-aaaa-756761755f73
export class CustomUrlSerializer implements UrlSerializer {
  private readonly defaultUrlSerializer: DefaultUrlSerializer =
    new DefaultUrlSerializer();
  private readonly slashRegex: RegExp = /%2F/g;

  // Parse the URL using the default serializer
  parse(url: string): UrlTree {
    return this.defaultUrlSerializer.parse(url);
  }

  // Serialize the URL tree and replace %2F with /
  serialize(tree: UrlTree): string {
    const path: string = this.defaultUrlSerializer.serialize(tree);
    return path.replace(this.slashRegex, '/');
  }
}
